import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from 'vue-router'
import Events from '@/api/events'
import AgentsEvents from '@/api/agentsEvents'
import moment from 'moment'
import agentEvents from './store/agentEvents'
import offdates from './store/offDates'

import events from './api/events'
Vue.use(Vuex)

Array.prototype.sortBy = function(p) {
  return this.slice(0).sort(function(a, b) {
    return a[p] > b[p] ? 1 : a[p] < b[p] ? -1 : 0
  })
}

Array.prototype.sortByDesc = function(p) {
  return this.slice(0).sort(function(a, b) {
    return a[p] > b[p] ? -1 : a[p] < b[p] ? 1 : 0
  })
}

export default new Vuex.Store({
  state: {
    id: localStorage.getItem('id') || null,
    name: localStorage.getItem('name') || null,
    role_id: localStorage.getItem('role_id') || null,
    token: localStorage.getItem('token') || null,
    api_url: 'http://localhost/aegisbook-api/public/api',
    dashboard_mode: false,
    eventData: {},
    events: [],
    eventsDeleted: [],
    events_types: [],
    users: [],
    groups: [],
    activeStart: null,
    activeEnd: null,
    timezone: localStorage.getItem('timezone') || null,
    editMode: true,
    now: localStorage.getItem('now') || null,
    userTimezone: localStorage.getItem('user_timezone') || null,
    loading: false,
    needsResetPassword: false,
    calendarNotification: '',
    window: {
      width: 0,
      height: 0
    },
    current_view: null,
    available_time: [],
    show_event_dialog: false,
    day_events: [],
    current_time: null,
    offdates: []
  },
  mutations: {
    setActiveStart: (state, newValue) => {
      state.activeStart = newValue
    },

    setActiveEnd: (state, newValue) => {
      state.activeEnd = newValue
    },

    changeDrawerState: (state, newvalue) => {
      state.drawer = newvalue
    },
    SET_EVENT: (state, val) => {
      state.event = val
    },
    SET_ROLE: (state, role_id) => {
      state.role_id = role_id
    },

    SET_ID: (state, id) => {
      state.id = id
    },

    SET_TOKEN: (state, token) => {
      state.token = token
    },

    SET_NAME: (state, name) => {
      state.name = name
    },
    DESTROY_ROL: state => {
      state.role_id = null
      localStorage.removeItem('role_id')
    },
    DESTROY_TOKEN: state => {
      state.token = null
      localStorage.removeItem('token')
    },

    DESTROY_ID: state => {
      state.id = null
      localStorage.removeItem('id')
    },

    DESTROY_NAME: state => {
      state.name = null
      localStorage.removeItem('name')
    },

    setDashboardMode: (state, value) => {
      state.dashboard_mode = value
    },

    SET_EVENTS: (state, value) => {
      state.events = value
    },
    SET_EVENTS_DELETED: (state, value) => {
      state.eventsDeleted = value
    },
    SET_EVENT_TYPES: (state, value) => {
      state.events_types = value
    },
    SET_USERS: (state, value) => {
      state.users = value
    },
    SET_GROUPS: (state, value) => {
      state.groups = value
    },
    SET_TIMEZONE: (state, value) => {
      state.timezone = value
    },
    SET_EDIT_MODE: (state, value) => {
      state.editMode = value
    },
    SET_NOW: (state, value) => {
      state.now = value
    },
    SET_USER_TIMEZONE: (state, value) => {
      state.userTimezone = value
    },
    SET_LOADING: (state, value) => {
      state.loading = value
    },
    SET_WINDOW_SIZE: (state, window) => {
      state.window.width = window.innerWidth
      state.window.height = window.innerHeight
    },
    SET_CURRENT_VIEW: (state, value) => {
      state.current_view = value
    },

    SET_CALENDAR_NOTIFICATION: (state, value) => {
      state.calendarNotification = value
    },
    SET_AVAILABLE_TIME: (state, value) => {
      state.available_time = value
    },
    SET_SHOW_EVENT_DIALOG: (state, value) => {
      state.show_event_dialog = value
    },
    SET_DAY_EVENTS: (state, value) => {
      state.day_events = value
    },
    SET_CURRENT_TIME: (state, value) => {
      state.current_time = value
    }
  },
  actions: {
    setEvent(eventData) {
      this.commit('SET_EVENT', eventData)
    },
    getCurrentTime(state, timezone) {
      let _this = this
      axios({
        method: 'get',
        url: process.env.VUE_APP_API_URL + '/getCurrentTime',
        params: { timezone: timezone },
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + this.state.token
        }
      })
        .then(response => {
          console.log('now: ', response.data.now)
          _this.commit('SET_CURRENT_TIME', response.data.now)
        })
        .catch(error => {
          console.log(error)
          if (error.response.status == 401) {
            _this.dispatch('removeCredentials')
            router.push({
              name: 'Login'
            })
          }
        })
    },
    updateNow() {
      let _this = this
      axios
        .get(
          process.env.VUE_APP_API_URL +
            '/now' +
            '/' +
            this.state.id +
            '/' +
            this.state.editMode,
          {
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + this.state.token
            }
          }
        )
        .then(response => {
          console.log('se cambio el now A: ', response.data.now)

          _this.commit('SET_NOW', response.data.now)
        })
    },

    selectAllUsers() {
      let users = this.state.users
      console.log('usersInSelection', this.state.users)

      //Clear the users
      for (var i in users) {
        users[i].checked = true
      }

      //Clear the groups
      for (var h in this.state.groups) {
        this.state.groups[h].checked = true
      }
    },

    removeCredentials() {
      this.commit('DESTROY_ID')
      this.commit('DESTROY_ROL')
      this.commit('DESTROY_NAME')
      this.commit('DESTROY_TOKEN')
    },
    clearUsersSelected() {
      let users = this.state.users
      console.log('usersInSelection', this.state.users)

      //Clear the users
      for (var i in users) {
        users[i].checked = false
      }

      //Clear the groups
      for (var h in this.state.groups) {
        this.state.groups[h].checked = false
      }
    },
    loadEventsTypes(state) {
      state.commit('SET_EVENT_TYPES', [
        { id: 1, name: 'Avalability' },
        { id: 2, name: 'Appointment' }
      ])
    },

    async getAvailabilty({ commit }, options) {
      try {
        let response = await AgentsEvents.getAvailableTime({
          start: options.start,
          end: options.start
        })
        commit('SET_AVAILABLE_TIME', response.data.availables)
      } catch (e) {
        console.error(e)
      }
    },

    async userSelection(userId) {
      let _this = this
      let users = this.state.users

      console.log('userId', userId)

      for (var i in users) {
        if (this.state.editMode === true) {
          if (users[i].id != userId) {
            users[i].checked = false
          } else {
            // selectedUserId = users[i].id;
            users[i].checked = true
          }
        } else {
          if (users[i].id == userId) {
            users[i].checked = !users[i].checked
            break //Stop this loop, we found it!
          }
        }
      }
      this.commit('SET_USERS', users)
      console.log('lista_usuarios', users)
      console.log('usersSelected', this.getters.getSelectedUsers)

      await axios
        .get(
          process.env.VUE_APP_API_URL +
            '/now' +
            '/' +
            _this.getters.getSelectedUsers +
            '/' +
            _this.state.editMode,
          {
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + _this.state.token
            }
          }
        )
        .then(response => {
          console.log('se cambio el now A: ', response.data.now)

          _this.commit('SET_NOW', response.data.now)
          _this.commit('SET_TIMEZONE', response.data.timezone)
          localStorage.setItem('now', response.data.now)
          localStorage.setItem('timezone', response.data.timezone)
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.dispatch('removeCredentials')
            router.push({
              name: 'Login'
            })
          }
          console.log(error)
        })

      //Check if all users in group selected
      let groupname = this.state.users.filter(item => item.id === userId)[0]
        .group_name
      let usersInGroupChecked = 0
      for (var k in this.state.users) {
        if (this.state.users[k].group_name === groupname) {
          usersInGroupChecked++
        }
      }
      console.log('groupname', groupname)
      let usersInGroup = this.state.users.filter(
        user => user.group_name === groupname && user.checked === true
      )
      console.log({ usersInGroup })
      if (usersInGroupChecked === usersInGroup.length) {
        for (var h in this.state.groups) {
          if (this.state.groups[h].name == groupname) {
            console.log(this.state.groups[h].name)
            this.state.groups[h].checked = true
          }
        }
        this.dispatch('groupSelection', groupname)
      } else {
        //Uncheck the group if not all users selected
        for (var j in this.state.groups) {
          if (this.state.groups[j].name == groupname) {
            console.log(this.state.groups[j].name)
            this.state.groups[j].checked = false
          }
        }
      }

      console.log('editmode..', this.state.editMode)
      let user = this.state.users.filter(user => user.id === userId)[0]
      if (this.state.editMode) {
        console.log('timezone:', user.timezone)
        this.commit('SET_TIMEZONE', user.timezone)
      }
      this.dispatch('loadEvents')
      return true
    },
    async groupSelection(groupName) {
      if (this.state.editMode) return
      let users = this.state.users
      let group = this.state.groups.filter(item => item.name === groupName)[0]
      console.log({ groups: this.state.groups })

      for (var i in users) {
        if (users[i].group_name == groupName) {
          users[i].checked = group.checked
        }
      }
      await this.commit('SET_USERS', users)
      this.dispatch('loadEvents')
    },
    notifyCalendar(state, notification) {
      this.commit('SET_CALENDAR_NOTIFICATION', notification)
    },
    async loadEvents(_state, date) {
      if (!date) return
      let state = this.state
      this.commit('SET_LOADING', true)
      let usersSelected = []

      //this is incase it goes empty
      if (usersSelected.length === 0) {
        usersSelected.push(0)
      }

      if (state.activeStart === undefined || state.activeStart === null) {
        return
      }

      let current_view = JSON.parse(localStorage.getItem('current_view'))
      let viewType = 'dayGridMonth'
      if (current_view) {
        viewType = current_view.type
      }

      let startDate = state.activeStart
      let endDate =
        viewType == 'timeGridDay' ? state.activeStart : state.activeEnd

      if ((viewType == 'dayGridMonth' || viewType == 'timeGridDay') && date) {
        startDate = date
        endDate = date
      }

      let editMode = state.editMode ? 'true' : 'false'
      console.log({ editMode })

      /* let urlevents =
        process.env.VUE_APP_API_URL +
        '/events/' +
        viewType +
        '/' +
        startDate +
        '/' +
        endDate

      console.log(urlevents)
      console.log(this.getters.getSelectedUsers)

      let headers = {
        Authorization: 'Bearer ' + state.token //the token is a variable which holds the token
      }
      await axios
        .get(urlevents, { headers }, { usersSelected })*/
      events
        .index({
          viewType,
          start: startDate,
          end: endDate
        })

        .then(response => {
          //update the events list
          console.log('que trajo', response)
          let events = response.data.events
          let availables = response.data.availables
          let eventsDeleted = response.data.deletedEvents
          console.log({ events })
          state.users.forEach(function(item) {
            let color = item.backgroundColor
            let userId = item.id

            events.forEach(function(item2, index2, arr2) {
              if (item2.user_id === userId) {
                arr2[index2].backgroundColor = '#' + color
              }

              if (item2.status_id === 3) {
                arr2[index2].classNames = 'cancelled'
              }

              if (item2.status_id === 2 && item2.event_type_id == 2) {
                arr2[index2].classNames = 'checkmark'
              }
            })
          })

          events.forEach(function(item2, index2, arr2) {
            //Set the acronym to the title
            let username = arr2[index2].user_name
            var matches = username.match(/\b(\w)/g)
            username = matches.join('') // JSON
            arr2[index2].title =
              arr2[index2].title === ''
                ? username
                : arr2[index2].title + ' - ' + username
          })

          console.log('in loadEvents', current_view)

          //If the view is the day view, load the events in the calendar, omit otherwise
          if (viewType == 'timeGridDay') {
            //this.commit('SET_EVENTS', events)
            //Clear the day_events
            this.commit('SET_DAY_EVENTS', events)

            console.log('EVENTOS BORRADOS', state.eventsDeleted)
          }

          if (viewType == 'dayGridMonth') {
            //Clear the calendar events on the monthly view
            //this.commit('SET_EVENTS', [])
            //Set the events to the list in the calendar
            this.commit('SET_DAY_EVENTS', events)
            this.commit('SET_EVENTS_DELETED', eventsDeleted)
          }

          this.commit('SET_AVAILABLE_TIME', availables)
          this.commit('SET_LOADING', false)
        })
        .catch(error => {
          this.commit('SET_LOADING', false)
          console.log({ error })
          if (error.response.status == 401) {
            this.dispatch('removeCredentials')
            router.push({
              name: 'Login'
            })
          }
        })
    },
    async loadTodayEvents({ commit }) {
      return new Promise(async (resolve, reject) => {
        const today = moment().format('YYYYMMDD')
        try {
          let response = await Events.index({
            viewType: 'dayGridMonth',
            start: today,
            end: today
          })

          commit('SET_DAY_EVENTS', response.data.events)
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },
    async loadAgentEvents(state, payload) {
      console.log('events loaded', state, payload)
      try {
        const response = await Events.index(payload)
        console.log('EVENTS LOADED', response)
        this.commit('SET_EVENTS', response.data.events)
      } catch (e) {
        console.error(e)
      }
    },
    async loadUsers() {
      console.log('cargar usuarios')
      let headers = {
        Authorization: 'Bearer ' + this.state.token //the token is a variable which holds the token
      }
      let usersUrl = process.env.VUE_APP_API_URL + '/users/get_agents'
      await axios
        .get(usersUrl, { headers })
        .then(response => {
          //Here get only the group's names(no repeat)
          let groups = []
          for (let i = 0; i < response.data.users.length; i++) {
            //flatten to only get the group's name
            let _groups = groups.map(a => a.name)
            if (!_groups.includes(response.data.users[i].group_name)) {
              //add the group to the array with default checked false
              groups.push({
                name: response.data.users[i].group_name,
                checked: false
              })
            }
          }
          groups.sort(function(a, b) {
            if (a.name > b.name) {
              return 1
            }
            if (a.name < b.name) {
              return -1
            }
            // a must be equal to b
            return 0
          })
          this.commit('SET_USERS', response.data.users)
          this.commit('SET_GROUPS', groups)
          //Convert checked to boolean
          this.state.users.forEach(function(part, index, theArray) {
            theArray[index].checked = theArray[index].checked === 1
          })
        })
        .catch(error => {
          console.log({ error })
          if (error.response.status == 401) {
            this.dispatch('removeCredentials')
            router.push({
              name: 'Login'
            })
          }
        })
    }
  },

  getters: {
    loggedIn(state) {
      return (
        state.token !== null &&
        state.token !== undefined &&
        state.token !== 'undefined'
      )
    },
    getUniqueUsers(state) {
      let users = []
      console.log('usuario 0=>', state.users)
      state.users.forEach(item => {
        if (!users.map(item2 => item2.id).includes(item.id)) {
          users.push(item)
        }
      })

      for (let index = 0; index < users.length; index++) {
        let user = users[index]
        let availables = state.available_time
        if (availables) {
          let agent_availables = availables.filter(
            item => item.user_name == user.name
          )
          user.available_time = agent_availables.length
        } else {
          user.available_time = 0
        }
      }

      users = users.sortByDesc('available_time')
      console.log('usuario final ', users)
      return users
    },
    getSelectedUsers(state) {
      let selectedUserId = []
      for (var i in state.users) {
        if (state.users[i].checked == true) {
          selectedUserId.push(state.users[i].id)
        }
      }
      return selectedUserId
    }
  },
  modules: { agentEvents, offdates }
})
